import React, { useState, useEffect } from 'react';
import { nodeApi } from '../../services/api';

const ContextInfo = ({ label, value, isLoading = false }) => {
    if (!value && !isLoading) return null;
    return (
        <div className="bg-gray-700 rounded-lg px-3 py-1 text-center min-w-[80px]">
            <div className="text-gray-400 text-xs font-bold uppercase">{label}</div>
            <div className="text-white font-bold text-lg truncate" title={value}>
                {isLoading ? '...' : value}
            </div>
        </div>
    );
};

const ContextDisplay = ({ context }) => {
    const [sessionName, setSessionName] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const fetchDisplayData = async () => {
            if (!context) return;
            const sid = String(context.sessionId || '').trim();
            if (!sid || sid === 'default-session' || sid === '111222' || sid.startsWith('sess_')) {
                setSessionName(sid ? sid.substring(0, 8) : 'Par défaut');
                return;
            }
            setLoading(true);
            try {
                const response = await nodeApi.get(`/api/sessions/${encodeURIComponent(sid)}`);
                if (!cancelled && response.data.success) {
                    setSessionName(response.data.session.name || sid.substring(0, 8));
                }
            } catch {
                if (!cancelled) setSessionName(sid.substring(0, 8));
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        fetchDisplayData();
        return () => { cancelled = true; };
    }, [context?.sessionId]);

    if (!context) return null;

    // Formatage du nom utilisateur pour affichage
    const displayUser = context.user === 'learner1' ? 'Utilisateur par défaut' : context.user;
    
    // Mapping des stratégies vers des codes fonctionnels pour l'affichage
    const strategyDisplayMapping = {
        'smart_test1': 'Adaptive Smart',
        'basic_sequential': 'Sequential',
        'difficulty_adaptive': 'Adaptive',
        '2': 'Random',
        '4': 'Random',
        'Random': 'Random'
    };
    
    // Formatage de la stratégie
    const displayStrategy = strategyDisplayMapping[context.strategy] || context.strategy;

    // Formatage de l'examen - juste l'ID en majuscules
    const displayExam = context.exam ? context.exam.toUpperCase() : 'N/A';

    return (
        <div className="flex items-center space-x-2">
            <ContextInfo label="User" value={displayUser} />
            <ContextInfo 
                label="Session" 
                value={sessionName || (context.sessionId ? context.sessionId.substring(0, 8) : 'N/A')} 
                isLoading={loading && context.sessionId && context.sessionId !== 'default-session'}
            />
            <ContextInfo 
                label="Exam" 
                value={displayExam}
            />
            <ContextInfo label="Strategy" value={displayStrategy} />
        </div>
    );
};

export default ContextDisplay; 